import WorkerApiService from "../workerApiServices"

class DashboardService extends WorkerApiService {

    constructor() {
        super('/api/dashboard')
    }

    generateDashboard(periodoDias){
        let params = `?`
        params = `${params}&periodoDias=${periodoDias}`
        return this.get(`/generateDashboard${params}`)        
    }    

}


export default DashboardService
